import { Timestamp } from 'firebase/firestore';

export const createTimestamp = (dateStr, format = 'MM/DD/YYYY', isEndDate = false) => {
    try {
        const [first, second, third] = dateStr.split('/').map(part => part.trim());
        let month, day, year;

        if (format === 'MM/DD/YYYY') {
            month = first;
            day = second;
            year = third;
        } else { // DD/MM/YYYY
            day = first;
            month = second;
            year = third;
        }

        // If year is 2 digits, assume 20XX
        const fullYear = year.length === 2 ? `20${year}` : year;

        // Create a local date at noon to avoid any timezone issues
        const date = new Date(parseInt(fullYear), parseInt(month) - 1, parseInt(day));
        date.setHours(isEndDate ? 23 : 12, isEndDate ? 59 : 0, 0, 0);

        return Timestamp.fromDate(date);
    } catch (error) {
        console.error('Error creating timestamp from date:', dateStr, error);
        return null;
    }
};